export const blockIconsSearchFeed = (
	<span className='material-symbols-outlined'>feed</span>
);
